import draggable from "vuedraggable";
import { ToggleButton } from 'vue-js-toggle-button';
import Helper from '../../../Helper.js';

if($('#network-vetting').length){
    var app = new Vue({
        el: '#network-vetting',
        data: {
            networkId: networkId,
            networkSlug: networkSlug,
            networkGroupSlug: networkGroupSlug,
            applicationType: 'innovation',
            showSelectType: false,
            showCurrentQuestion: false,
            loading: true,
            network: {},
            currentQuestion: {},
            dependancyQuestion: false,
            Helper: Helper
        },
        methods: {
            get(){
                this.loading = true; 
                axios.get('/api/v1/network/'+this.networkSlug+'/questions/'+this.applicationType).then((response) =>  {
                    this.network = response.data;
                    if(this.network.innovations_level_id == 4){
                        this.applicationType = 'expert';
                    }
                    this.loading = false; 
                }).catch(error => {
                    this.errorHandler(error);
                    this.loading = false; 
                });
            },
            edit(question){
                this.currentQuestion = Object.assign({}, question);
                if(this.currentQuestion.dependancy_question_id){
                    this.dependancyQuestion = true;
                    this.currentQuestion.dependancyAnswers = [];
                    if(this.currentQuestion.dependancy_question_answers){
                        var array = this.currentQuestion.dependancy_question_answers.split(",");
                        array.forEach((value, key) => {
                            this.currentQuestion.dependancyAnswers[value] = true;
                        });
                    }
                }else{
                    this.dependancyQuestion = false;
                    this.currentQuestion.dependancyAnswers = [];
                }
                if (this.currentQuestion.answer_options) {
                    this.currentQuestion.answer_options.forEach((value) => {
                        if (value.tag) {
                            value.tag_id = value.tag.id
                            value.tag_name = value.tag.name
                        }
                    });
                }
                this.showCurrentQuestion = true;
            },
            create(){
                this.dependancyQuestion = false;
                this.currentQuestion = {
                    answer_options:[],
                    dependancyAnswers:[]
                };
                this.showSelectType = true;
            },
            updateOrder(event){
                let questionIds = this.network.criteria_questions.map(a => a.id);

                axios.patch('/api/v1/network/'+this.networkSlug+'/questions/'+this.applicationType+'/update-order', questionIds).then((response) =>  {
                    this.network = response.data;
                    this.loading = false; 
                    this.$toasted.success('Updated Order');
                }).catch(error => {
                    this.errorHandler(error);
                    this.loading = false; 
                });
            },
            destroy(question){
                if(confirm("Are you sure you wish to delete this question? You will no longer be able to see existing application answers to the question.")){
                    this.loading = true; 
                    axios.delete('/api/v1/network/'+this.networkSlug+'/questions/'+this.applicationType+'/'+question.id).then((response) =>  {
                        this.network = response.data;
                        this.loading = false; 
                        this.$toasted.success('Question Deleted');
                    }).catch((error) => {
                        this.errorHandler(error);
                        this.loading = false; 
                    });
                }
            },
            save(question){
                if(!question.question){
                    this.$toasted.error('Please add text for your question');
                    return;
                }

                if(question.answer_options.length){
                    var answersValidated = true;
                    question.answer_options.forEach((option, index) => {
                        if(!option.answer){
                            this.$toasted.error('One of your answer options does not have a label');
                            answersValidated = false;
                        }
                        if(option.score === null || option.score === ''){
                            this.$toasted.error('One of your answer options does not have a score');
                            answersValidated = false;
                        }
                    });
                    if(!answersValidated){
                        return;
                    }
                }else if(question.question_type_id != 4){
                    this.$toasted.error('Your question must contain at least 1 answer');
                    return;
                }

                if(this.dependancyQuestion){
                    if(!question.dependancy_question_id){
                        this.$toasted.error('You must select a dependancy question as you have it enabled');
                        return;
                    }
                    if(!question.dependancyAnswers.length){
                        this.$toasted.error('You must select answers for your dependancy question');
                        return;
                    }
                    if(question.dependancyAnswers.length){
                        question.dependancy_question_answers = [];
                        question.dependancyAnswers.forEach((value, key) => {
                            if(value){
                                question.dependancy_question_answers.push(key);
                            }
                        });
                        question.dependancy_question_answers = question.dependancy_question_answers.join(",");
                    }
                }else{
                    question.dependancy_question_id = null;
                    question.dependancy_question_answers = null;
                }
                if(question.id){
                    axios.patch('/api/v1/network/'+this.networkSlug+'/questions/'+this.applicationType, question).then((response) =>  {
                        this.network = response.data;
                        this.loading = false; 
                        this.showCurrentQuestion = false;
                        this.$toasted.success('Question Updated');
                    }).catch(error => {
                        this.errorHandler(error);
                        this.loading = false; 
                    });
                }else{
                    axios.post('/api/v1/network/'+this.networkSlug+'/questions/'+this.applicationType, question).then((response) =>  {
                        this.network = response.data;
                        this.loading = false; 
                        this.showCurrentQuestion = false;
                        this.$toasted.success('Question Added');
                    }).catch(error => {
                        this.errorHandler(error);
                        this.loading = false; 
                    });
                }
            },
            openCreationModal(id){
                this.currentQuestion.question_type_id = id;
                this.showSelectType = false;
                this.showCurrentQuestion = true;
            },
            addAnswer(){
                this.currentQuestion.answer_options.push({
                    answer: "",
                    score: 0                    
                });
            },
            removeAnswer(answers, answer){
                if(confirm("Are you sure you wish to delete this answer? You will no longer be able to see on existing applications where this answer was selected")){
                    if(answer.id){
                        this.currentQuestion.answer_options = answers.filter(function( obj ) {
                            return obj.id !== answer.id;
                        });
                    }else{
                        this.currentQuestion.answer_options = answers.filter(function( obj ) {
                            return obj.answer !== answer.answer;
                        });
                    }
                }
            },
            errorHandler(error){
                if(error.response && typeof error.response.data === 'string'){
                    this.$toasted.error(error.response.data);
                }else if(error.response){
                    this.$toasted.error(error.response.data.message);
                }else{
                    console.log(error);
                }
            }
        },
        components: {
            'draggable': draggable,
            'ToggleButton': ToggleButton,
        },
        mounted () {
            this.get();
        }
    });
}